import React, { useEffect, useState } from 'react';
import Select from "react-select";
import { getSelectList } from '../../../config/utils';
import { getAllConsignmentCarrierType, getAllConsignmentStatus, getAllConsignmentType } from '../../../store/actions/inventory.action';
import { useSelector } from 'react-redux';
import { fetchCompanyFilters, getFilterSellers } from '../../../store/actions/rateCard';
import {
    getAllSellersList
} from "../../../store/actions";
import _ from 'lodash';
import PropTypes from "prop-types";

/* istanbul ignore next */
const InboundFilter = (props) => {
    const { showFilter, handleReset, handleFilter, dispatch, filterData, setfilterData, sellerList, setSellerList, allSellers, setAllSellers } = props;
    const [allCarriers, setAllCarriers] = useState([]);
    const [consignmentList, setConsignmentList] = useState([]);
    const [companyList, setCompanyList] = useState([]);
    const [consignmentStatusList, setConsignmentStatusList] = useState([]);
    const { consignmentTypes, consignmentAllStatus } = useSelector((state) => state.InventoryManagement);
    const { filterCompanies, filterAllSellers } = useSelector((state) => state.RateCardReducer);
    const UserValue = useSelector((state) => state.auth.user);

    useEffect(() => {
        let companyList = filterCompanies?.Entity?.listCompanyMasterOrdersEntity || [];
        let sellerList = filterAllSellers?.EntityList || [];
        if (companyList.length) {
            setCompanyList(getSelectList(filterCompanies?.Entity?.listCompanyMasterOrdersEntity, 'Id', 'name'));
        }
        if (sellerList.length) {
            setAllSellers(getSelectList(sellerList, 'id', 'sellerName'));
            setSellerList(getSelectList(sellerList, 'id', 'sellerName'));
        }
    }, [filterCompanies, filterAllSellers]);

    const fetchSellers = async (companyList) => {
        if (companyList.length === 0) {
            setSellerList(allSellers);
            return;
        }
        let data = {
            companyIds: companyList,
        };
        let res = await getAllSellersList(data);
        if (res?.data?.Status === 200) {
            let dataList = res?.data?.Entity?.listSellerMasterOrdersEntity.map(
                (item) => {
                    return {
                        ...item,
                        label: item.sellerAndCompany,
                        value: item.id,
                    };
                }
            );
            setSellerList(dataList);
        }
    };

    const handleMultiSelect = (value, fieldName) => {
        setfilterData({
            ...filterData,
            [fieldName]: value
        });
        if (fieldName === "companyIdList") {
            let companyData = _.map(value, "Id");
            fetchSellers(companyData);
            if (filterData?.sellerIdList?.length) {
                const filteredSellers = filterData.sellerIdList.filter(seller =>
                    companyData.includes(parseInt(seller.companyIds))
                );
                setfilterData({ ...filterData, sellerIdList: filteredSellers, companyIdList: value })
            }
        }
    }

    useEffect(() => {
        let data = {
            pageIndex: 1,
            pageSize: 10,
            sortColumn: 'name',
            sortOrder: 'ascending'
        };
        let sellerData = {
            "pageIndex": 1,
            "pageSize": 10,
            "sortColumn": "name",
            "sortOrder": "ASCENDING",
            "companyIdList": [0],
            screenType: 2,
        };
        dispatch(fetchCompanyFilters(data));
        dispatch(getFilterSellers(sellerData));
    }, []);

    useEffect(() => {
        fetchCarriers();
    }, [])

    const fetchCarriers = () => {
        getAllConsignmentCarrierType().then(res => {
            if (res.data.Status === 200) {
                let carriersData = getSelectList(res.data.EntityList, 'id', 'carrierName');
                setAllCarriers(carriersData);
            }
        });
    }

    useEffect(() => {
        if (!consignmentTypes.length) {
            dispatch(getAllConsignmentType());
        } else {
            let consignmentData = getSelectList(consignmentTypes, 'id', 'name');
            setConsignmentList(consignmentData);
        }
    }, [consignmentTypes]);


    useEffect(() => {
        if (!consignmentAllStatus?.length) {
            dispatch(getAllConsignmentStatus());
        } else {
            let selectConsignmentStatusData = getSelectList(consignmentAllStatus, 'id', 'name');
            setConsignmentStatusList(selectConsignmentStatusData);
        }
    }, [consignmentAllStatus]);


    return (
        <div className={showFilter ? 'filterContainer show historyFilter' : 'filterContainer historyFilter'}>
            <div className='row mb10'>
                <div className='col-sm-12 col-lg-3 mobMb-10'>
                    <div className='row'>
                        <div className='col-12'>
                            <div className='labelHead'>Consignment Type</div>
                        </div>
                        <div className='col-12 fontFix'>
                            <Select
                                isMulti
                                closeMenuOnSelect={false}
                                options={consignmentList}
                                classNamePrefix="list"
                                id='consignmentTypeIdList'
                                name="consignmentTypeIdList"
                                value={filterData?.consignmentTypeIdList}
                                onChange={(value) =>
                                    handleMultiSelect(value, "consignmentTypeIdList")
                                }
                            />
                        </div>
                    </div>
                </div>
                <div className='col-sm-12 col-lg-3 mobMb-10'>
                    <div className='row carriers'>
                        <div className='col-12'>
                            <div className='labelHead'>Carrier</div>
                        </div>
                        <div className='col-12 fontFix carrierIdList'>
                            <Select
                                closeMenuOnSelect={false}
                                isMulti
                                options={allCarriers}
                                classNamePrefix="allCarriers"
                                name="carrierIdList"
                                id="carrierIdList"
                                value={filterData.carrierIdList}
                                onChange={(value) =>
                                    handleMultiSelect(value, "carrierIdList")
                                }
                            />
                        </div>
                    </div>
                </div>
                <div className='col-sm-12 col-lg-3 mobMb-10'>
                    <div className='row'>
                        <div className='col-12'>
                            <div className='labelHead'>Status</div>
                        </div>
                        <div className='col-12 fontFix consignmentStatusIdList'>
                            <Select
                                closeMenuOnSelect={false}
                                isMulti
                                options={consignmentStatusList}
                                classNamePrefix="listStatus"
                                id="consignmentStatusIdList"
                                name="consignmentStatusIdList"
                                value={filterData?.consignmentStatusIdList}
                                onChange={(value) =>
                                    handleMultiSelect(value, "consignmentStatusIdList")
                                }
                            />
                        </div>
                    </div>
                </div>
                <div className='col-sm-12 col-lg-3 mobMb-10'>
                    <div className='row'>
                        <div className='col-12'>
                            <div className='labelHead'>Consignment Id</div>
                        </div>
                        <div className='col-12'>
                            <input
                                type="text"
                                className='form-control searchText consignmentId'
                                value={filterData.consignmentNumber}
                                onChange={(e) => handleMultiSelect(e.target.value, "consignmentNumber")}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className='row mb10'>

                <div className='col-sm-12 col-lg-3 mobMb-10'>
                    <div className='row'>
                        <div className='col-12'>
                            <div className='labelHead'>Tracking Number</div>
                        </div>
                        <div className='col-12'>
                            <input
                                type="text"
                                className='form-control searchText trackingNumber'
                                value={filterData.trackingNumber}
                                onChange={(e) => handleMultiSelect(e.target.value, "trackingNumber")}
                            />
                        </div>
                    </div>
                </div>
                {UserValue?.Value?.roleName !== 'Seller' && (
                    <>
                        <div className='col-sm-12 col-lg-3 mobMb-10'>
                            <div className='row'>
                                <div className='col-12'>
                                    <div className='labelHead'>Company</div>
                                </div>
                                <div className='col-12 fontFix'>
                                    <Select
                                        isMulti
                                        closeMenuOnSelect={false}
                                        options={companyList}
                                        classNamePrefix="list"
                                        id='companyIdList'
                                        name="companyIdList"
                                        value={filterData?.companyIdList}
                                        onChange={(value) =>
                                            handleMultiSelect(value, "companyIdList")
                                        }
                                    />
                                </div>
                            </div>
                        </div>

                        <div className='col-sm-12 col-lg-3 mobMb-10'>
                            <div className='row'>
                                <div className='col-12'>
                                    <div className='labelHead'>Seller</div>
                                </div>
                                <div className='col-12 fontFix'>
                                    <Select
                                        isMulti
                                        closeMenuOnSelect={false}
                                        options={sellerList}
                                        classNamePrefix="list"
                                        id='sellerIdList'
                                        name="sellerIdList"
                                        value={filterData?.sellerIdList}
                                        onChange={(value) =>
                                            handleMultiSelect(value, "sellerIdList")
                                        }
                                    />
                                </div>
                            </div>
                        </div>
                    </>
                )}
                <div className='col-lg-3 col-sm-12'>
                    <div className='row'>
                        <div className='col-12'>
                            <div className='hidLbl'>-</div>
                        </div>
                        <div className='col-12 flexEnd'>
                            <button
                                className="btn cus-primary-transparent-btn top-btn"
                                onClick={(e) => handleReset(e, 'clear')}
                            >
                                Clear Filter
                            </button>
                            <button
                                className="cus-seconday-bg-btn btn filterBtn"
                                onClick={() => handleFilter(true)}
                            >
                                Apply
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

InboundFilter.propTypes = {
    showFilter: PropTypes.bool,
    handleReset: PropTypes.func,
    handleFilter: PropTypes.func,
    dispatch: PropTypes.func,
    filterData: PropTypes.object,
    setfilterData: PropTypes.func,
    sellerList: PropTypes.array,
    setSellerList: PropTypes.func,
    allSellers: PropTypes.array,
    setAllSellers: PropTypes.func
}

export default InboundFilter;